/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */

export const ENGINE_REGEX   = /^\d{0,8}$/;
export const ODOMETER_REGEX = /^\d{0,8}(\.\d{0,2})?$/;

/**
 * Provides a utility which determines if the specified value is a valid
 * odometer reference value.
 *
 * ```typescript
 *   
 *   import {isValidOdometerReference} from '@ion/core/src/utils/';
 * 
 *   isValidOdometerReference(-33) // false
 *   isValidOdometerReference(12) // true
 *   isValidOdometerReference(22.3) // true
 *
 * ```
 */
export const isValidOdometerReference = (val: number): boolean => {
  return !!ODOMETER_REGEX.test(val.toString());
};

/**
 * Provides a utility which determines if the specified value is a valid
 * engine hours reference value.
 *
 * ```typescript
 *   
 *   import {isValidEngineReference} from '@ion/core/src/utils/';
 * 
 *   isValidEngineReference(-51) // false
 *   isValidEngineReference(23) // true
 *   isValidEngineReference(123456) // true
 *
 * ```
 */
export const isValidEngineReference = (val: number): boolean => {
  return !!ENGINE_REGEX.test(val.toString());
};
